export interface BatchTrcContentDataRegisterRequest {
  startNumFrom: string
  startNumTo: string
  convertHyoukiToFull: boolean
  registeredContentDataType: string
  contentDataFile: string
  memo: string
  batchType: string
}

export function BatchTrcContentDataRegisterRequestToJSON(
  value: BatchTrcContentDataRegisterRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    convert_hyouki_to_full: value.convertHyoukiToFull,
    registered_content_data_type: value.registeredContentDataType,
    content_data_file: value.contentDataFile,
    memo: value.memo,
    batch_type: value.batchType
  }
}
